/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        link: {
            color: {
                value: "#385F99",
                type: "color",
            },
            fontWeight: {
                value: 700,
                type: "fontWeight",
            },
            textDecoration: {
                value: "none",
                type: "textDecoration",
            },
            hover: {
                color: {
                    value: "#294772",
                    type: "color",
                },
                textDecoration: {
                    value: "underline",
                    type: "textDecoration",
                },
            },
            active: {
                color: {
                    value: "#21395B",
                    type: "color",
                },
            },
            focus: {
                borderRadius: {
                    value: "2px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
